import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2021f913&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2021f913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021f913",
  null
  
)

export default component.exports